import React from 'react';
import PropTypes from 'prop-types';

import Chip from '@material-ui/core/Chip';

import { orange, red, yellow } from '@material-ui/core/colors';

const ColorChip = ({ className, important, maintain, emergency, label }) => {
  const bgColor = important
    ? yellow[500]
    : maintain
    ? orange[700]
    : emergency
    ? red[900]
    : '';
  const textColor = maintain || emergency ? 'white' : 'black';

  return (
    <Chip
      className={className}
      label={label}
      sx={{
        bgcolor: bgColor,
        color: textColor,
        fontWeight: 'bold',
      }}
    />
  );
};

ColorChip.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  important: PropTypes.bool,
  maintain: PropTypes.bool,
  emergency: PropTypes.bool,
};

export default ColorChip;
